// extracted by mini-css-extract-plugin
module.exports =  {"translationToggle":"PFtgbTTp"};